import { graphql } from 'gatsby'
import React, { FC } from 'react'
import styled from 'styled-components'

import useSiteSettings from '../../../hooks/useSiteSettings'
import MenuEntryLink from '../header/MenuEntryLink'

const Separator: React.FC<{ index: number }> = ({ index }) => {
  return index > 0 ? <span aria-hidden="true">•</span> : null
}

const StyledMenuEntryLink = styled(MenuEntryLink)`
  display: inline-block;
  margin: 0 10px;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

export const FooterLegalMenu: FC = () => {
  const { footerLegalMenu: menuEntries } = useSiteSettings() || {}

  return (
    <>
      {menuEntries &&
        menuEntries.reduce((acc: React.ReactElement[], entry, index) => {
          if (!entry) return acc
          const { name: entryName } = entry
          if (!entryName) return acc
          acc.push(
            <React.Fragment key={entryName}>
              <Separator index={index} />
              <StyledMenuEntryLink link={entry.link}>{entryName}</StyledMenuEntryLink>
            </React.Fragment>,
          )
          return acc
        }, [])}
    </>
  )
}

export const footerLegalMenu = graphql`
  fragment footerLegalMenuFragment on SanitySiteSettings {
    footerLegalMenu {
      ...MenuEntryFragment
    }
  }
`
